export const CompassMarkInverse = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.3244 23.2877V32.2547H14.4854V23.2877H23.3244V14.3267H7.19937C6.33837 14.3327 5.64537 15.0347 5.65037 15.8957C5.65037 15.9027 5.65037 15.9097 5.65037 15.9177V39.6727C5.63237 40.5337 6.31637 41.2457 7.17737 41.2627C7.18437 41.2627 7.19137 41.2627 7.19937 41.2627H30.5944C31.4554 41.2567 32.1484 40.5547 32.1434 39.6937C32.1434 39.6867 32.1434 39.6797 32.1434 39.6717V23.2877H23.3254H23.3244Z"
      fill="url(#paint0_linear_818_487)"
    />
    <path
      d="M23.3244 5.35984V14.3268H32.1844V23.2878H40.9974V6.92984C41.0154 6.06884 40.3314 5.35684 39.4704 5.33984C39.4634 5.33984 39.4564 5.33984 39.4484 5.33984L23.3234 5.36084L23.3244 5.35984Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_818_487"
        x1="30.7454"
        y1="15.9457"
        x2="15.5804"
        y2="31.1117"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.2" stopColor="white" stopOpacity="0.6" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
    </defs>
  </svg>
);
